import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Gamepad2, Star } from "lucide-react";
import { format } from "date-fns";
import { ar } from "date-fns/locale";

interface Props {
  childGames: any[];
}

export default function ParentGameResults({ childGames }: Props) {
  if (childGames.length === 0) {
    return (
      <Card className="shadow-card">
        <CardContent className="py-12 text-center">
          <Gamepad2 className="w-10 h-10 text-muted-foreground/30 mx-auto mb-2" />
          <p className="text-muted-foreground text-sm">لا توجد نتائج ألعاب بعد</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="shadow-card">
      <CardContent className="p-0">
        <ScrollArea className="max-h-[400px]">
          <div className="divide-y">
            {childGames.map((game) => (
              <div key={game.id} className="p-4 flex items-center gap-3 hover:bg-muted/30 transition-colors">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <Gamepad2 className="w-5 h-5 text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-foreground text-sm">{game.game_type}</p>
                  <p className="text-xs text-muted-foreground">{format(new Date(game.played_at), "dd MMM yyyy", { locale: ar })}</p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: game.stars || 0 }).map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                  <Badge variant="outline" className="text-xs">{game.score}/{game.max_score}</Badge>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
